(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 23977:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(71600);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(68671));
var _jsxRuntime = __webpack_require__(52322);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M17 20.41 18.41 19 15 15.59 13.59 17 17 20.41zM7.5 8H11v5.59L5.59 19 7 20.41l6-6V8h3.5L12 3.5 7.5 8z"
}), 'CallMergeOutlined');
exports.Z = _default;

/***/ }),

/***/ 91418:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(71600);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(68671));
var _jsxRuntime = __webpack_require__(52322);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M4 4h16v12H5.17L4 17.17V4m0-2c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4zm2 10h8v2H6v-2zm0-3h12v2H6V9zm0-3h12v2H6V6z"
}), 'ChatOutlined');
exports.Z = _default;

/***/ }),

/***/ 87801:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(71600);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(68671));
var _jsxRuntime = __webpack_require__(52322);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
}), 'MoodOutlined');
exports.Z = _default;

/***/ }),

/***/ 87314:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(64796);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 64796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47842);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(62197);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67550);
/* harmony import */ var _mui_material_Button__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(62048);
/* harmony import */ var _mui_icons_material_ChatOutlined__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(91418);
/* harmony import */ var _mui_icons_material_CallMergeOutlined__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(23977);
/* harmony import */ var _mui_icons_material_MoodOutlined__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(87801);
/* harmony import */ var _landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87781);
/* harmony import */ var _landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _public_assets_icons_customIconLib__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35629);













var LandingPage = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("readyCheck"), carouselStatus = ref[0], setCarouselStatus = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), timerPause = ref1[0], setTimerPause = ref1[1];
    var handleHover = function(title) {
        setCarouselStatus(title);
        setTimerPause(true);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!timerPause) {
            var interval = setInterval(function() {
                if (carouselStatus === "readyCheck") {
                    setCarouselStatus("codeExchange");
                } else if (carouselStatus === "codeExchange") {
                    setCarouselStatus("scoreSub");
                } else if (carouselStatus === "scoreSub") {
                    setCarouselStatus("readyCheck");
                }
            }, 4000);
            return function() {
                return clearInterval(interval);
            };
        }
    }, [
        timerPause,
        carouselStatus,
        setCarouselStatus
    ]);
    var uspCardStyle = {
        width: {
            xs: 260,
            sm: 260,
            md: 268,
            lg: 320,
            xl: 360
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        className: (_landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6___default().landingpage),
        sx: {
            bgcolor: "color.background"
        },
        "data-cy": "landingpage",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                className: (_landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6___default().gradientBox),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        className: (_landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6___default().jumbotron),
                        "data-cy": "landingpage-jumbotron",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                className: (_landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6___default().header),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: "/assets/logo/namePrimary.svg",
                                        className: (_landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6___default().etournityLogo)
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        children: "PUBLIC ALPHA"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                variant: "headline",
                                className: (_landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6___default().headline),
                                children: "Save time & energy while organizing tournaments"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                className: (_landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6___default().buttonBox),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                        passHref: true,
                                        href: "/tournament/new",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                            className: (_landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6___default().createButton),
                                            variant: "contained",
                                            "data-cy": "createButton",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    src: "/assets/logo/brawlhallaLogo.svg"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                    variant: "label",
                                                    children: "Create Brawlhalla Tournament"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                        variant: "label",
                                        className: (_landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6___default().label),
                                        children: "1v1 - Single Elimination"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        className: (_landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6___default().graphicsContainer),
                        "data-cy": "graphicsContainer",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                variant: "headline",
                                className: (_landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6___default().headline),
                                children: "Built to solve your problems"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6___default().hosthubBox), (_landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6___default().graphicsWrapper)),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                        sx: {
                                            width: {
                                                xs: 328,
                                                sm: 398,
                                                md: 418,
                                                lg: 428,
                                                xl: 433
                                            },
                                            mr: {
                                                xs: 0,
                                                sm: "1.5rem",
                                                md: "3rem",
                                                lg: "3rem",
                                                xl: "3rem"
                                            }
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: "/assets/landingpage/HostHub.svg"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                        sx: {
                                            width: {
                                                xs: 328,
                                                sm: 398,
                                                md: 418,
                                                lg: 428,
                                                xl: 433
                                            }
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                variant: "title",
                                                children: "Host Hub - For Organizers & Moderators"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                variant: "body",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: "Complete tournament control"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: "Easy player management"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: "Automatic Bracket Creation"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            children: "Quickly help players"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6___default().matchlobbyBox), (_landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6___default().graphicsWrapper)),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                        sx: {
                                            width: {
                                                xs: 328,
                                                sm: 398,
                                                md: 418,
                                                lg: 428,
                                                xl: 456
                                            },
                                            textAlign: "left",
                                            lineHeight: {
                                                xs: "1rem",
                                                md: "1.25rem"
                                            },
                                            fontSize: {
                                                xs: "0.875rem",
                                                md: "1rem"
                                            }
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                variant: "title",
                                                children: "Match Lobby - For the Players"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                variant: "body",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, (_landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6___default().liHover), carouselStatus === "readyCheck")),
                                                            "data-cy": "readyCheck",
                                                            onMouseOver: function() {
                                                                return handleHover("readyCheck");
                                                            },
                                                            onMouseOut: function() {
                                                                return setTimerPause(false);
                                                            },
                                                            children: "Check-in timer for each match"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, (_landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6___default().liHover), carouselStatus === "codeExchange")),
                                                            "data-cy": "codeExchange",
                                                            onMouseOver: function() {
                                                                return handleHover("codeExchange");
                                                            },
                                                            onMouseOut: function() {
                                                                return setTimerPause(false);
                                                            },
                                                            children: "Quick Lobby Code exchange for easy communication"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, (_landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6___default().liHover), carouselStatus === "scoreSub")),
                                                            "data-cy": "scoreSub",
                                                            onMouseOver: function() {
                                                                return handleHover("scoreSub");
                                                            },
                                                            onMouseOut: function() {
                                                                return setTimerPause(false);
                                                            },
                                                            children: "Simple Score Submission + Automatic comparison"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                        "data-cy": "matchlobby-graphic",
                                        sx: {
                                            width: {
                                                xs: 328,
                                                sm: 398,
                                                md: 418,
                                                lg: 428,
                                                xl: 433
                                            },
                                            maxWidth: 456,
                                            ml: {
                                                xs: 0,
                                                sm: 0,
                                                md: "3rem",
                                                lg: "3rem",
                                                xl: "3rem"
                                            }
                                        },
                                        children: carouselStatus === "readyCheck" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            "data-cy": "img",
                                            src: "/assets/landingpage/readyCheck.svg"
                                        }) : carouselStatus === "codeExchange" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            "data-cy": "img",
                                            src: "/assets/landingpage/codeExchange.svg"
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            "data-cy": "img",
                                            src: "/assets/landingpage/scoreSub.svg"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        "data-cy": "uspCards",
                        className: (_landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6___default().uspCards),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                className: (_landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6___default().card),
                                sx: uspCardStyle,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_ChatOutlined__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                        className: (_landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6___default().icon),
                                        color: "primary"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                        variant: "title",
                                        className: (_landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6___default().title),
                                        children: "Streamlined Communication"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                        variant: "body",
                                        className: (_landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6___default().body),
                                        children: "Players submit issues directly to your dashboard (Hub), easily solvable for you and your mods."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6___default().card), (_landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6___default().middle)),
                                sx: uspCardStyle,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_CallMergeOutlined__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                        className: (_landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6___default().icon),
                                        color: "primary"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                        variant: "title",
                                        className: (_landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6___default().title),
                                        children: "All-In-One Platform"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                        variant: "body",
                                        className: (_landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6___default().body),
                                        children: [
                                            "All relevant data in one place, no need for using spreadsheets.",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                            "Players simply exchange lobby codes, scores are compared automatically.",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                            "Built-in bracket generation (and they look great, too)"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                className: (_landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6___default().card),
                                sx: uspCardStyle,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_MoodOutlined__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                        className: (_landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6___default().icon),
                                        color: "primary"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                        variant: "title",
                                        className: (_landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6___default().title),
                                        children: "Easy to Use For Players"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                        variant: "body",
                                        className: (_landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6___default().body),
                                        children: [
                                            "Built to be intuitively usable - even for beginners.",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                            "Players are guided through your tournament, everything on one platform.",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                            "Also: dark mode! (suck it Smash)"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                className: (_landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6___default().backgroundBox),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    className: (_landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6___default().brightEBackground),
                    src: "/assets/landingpage/EtournityBrightE.svg"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                className: (_landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6___default().footerAlpha),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        className: (_landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6___default().textBox),
                        sx: {
                            width: {
                                xs: 328,
                                sm: 420,
                                lg: 508,
                                xl: 618
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                className: (_landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6___default().publicAlpha),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                        variant: "headline",
                                        className: (_landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6___default().alphaHeader),
                                        children: "This is a PUBLIC ALPHA!"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                        variant: "label",
                                        className: (_landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6___default().label),
                                        children: [
                                            "I repeat: ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                children: "ALPHA!"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                        variant: "title",
                                        className: (_landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6___default().title),
                                        children: "Current Tournament Support"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                        variant: "body",
                                        className: (_landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6___default().body),
                                        children: "Brawlhalla • 1v1 • Single Elimination"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {})
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                        variant: "title",
                                        children: "What to expect"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                        variant: "body",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    children: "New features are added based on your feedback"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    children: "Designs will change"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    children: "Some features feel unpolished and might break"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    children: "Unhappy with anything or have feature requests? Message us on Discord!"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                variant: "label",
                                className: (_landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6___default().reminder),
                                children: "Remember: We are building a platform FOR YOU. Tell us what you like and dislike!"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        className: (_landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6___default().discordBox),
                        sx: {
                            m: {
                                xs: 0,
                                sm: "4.25rem",
                                md: "4.25rem",
                                lg: "4.25rem",
                                xl: "4.25rem"
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                className: (_landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6___default().joinOurDiscord),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_public_assets_icons_customIconLib__WEBPACK_IMPORTED_MODULE_4__/* .DiscordIcon */ .D7, {
                                        className: (_landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6___default().logo)
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                        variant: "label",
                                        children: "Join our Discord"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
                                "data-cy": "discord-iframe",
                                src: "https://discord.com/widget?id=688104154425458693&theme=dark",
                                width: "350",
                                height: "500",
                                frameBorder: "0",
                                sandbox: "allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                className: (_landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6___default().footerMission),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        variant: "headline",
                        className: (_landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6___default().headline),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                children: "Be among the first"
                            }),
                            " to join our mission of building your favorite esports platform."
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        className: (_landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6___default().buttonBox),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                passHref: true,
                                href: "/tournament/new",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    "data-cy": "createButtonTwo",
                                    className: (_landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6___default().createButton),
                                    variant: "contained",
                                    color: "secondary",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: "/assets/logo/brawlhallaLogo.svg"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                            variant: "label",
                                            className: (_landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6___default().label),
                                            children: "Create Brawlhalla Tournament"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                variant: "label",
                                className: (_landingpage_module_scss__WEBPACK_IMPORTED_MODULE_6___default().label2),
                                children: "1v1 - Single Elimination"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (LandingPage);


/***/ }),

/***/ 87781:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#acf7f0","primaryaccent":"#8ed2cc","primaryhover":"#7cfff3","primaryfocus":"#4eb7ad","primarydisabled":"#547a77","secondary":"#f0acf7","secondaryAccent":"#d08bd7","secondaryDark":"#983fa1","tertiary":"#f7f0ac","void":"#0f0f0f","charcoal":"#1c1c1c","plastic":"#232323","steel":"#303030","mattBlack":"#393939","ashBlack":"#484848","white":"#efefef","middleGrey":"#8f8f8f","darkGrey":"#6b6b6b","yellowRedGradient":"linear-gradient(90deg, #f7f0ac 0%, #f0acf7 100%)","logoGradient":"linear-gradient(95deg, #f7f0ac 5%, #acf7f0 50%, #f0acf7 95%)","gradient":"linear-gradient(70deg, #acf7f0 0%, #f0acf7 100%)","success":"#53e72e","successDisabled":"#39711a","error":"#f44040","divider":"#b4b4b4","inputFontColor":"#ababab","inputFontDisabled":"#3f3f3f","muiPrimary":"#00e0b5","muiOnPrimary":"#00382b","muiPrimaryContainer":"#005140","muiOnPrimaryContainer":"#0dffd2","muiSecondary":"#b2cdc2","muiOnSecondary":"#1d352e","muiSecondaryContainer":"#344c44","muiOnSecondaryContainer":"#cee9de","muiTertiary":"#a9cbe2","muiOnTertiary":"#0e3446","muiTertiaryContainer":"#294b5e","muiOnTertiaryContainer":"#c4e7ff","muiError":"#ffb4a9","muiErrorContainer":"#930006","muiOnError":"#680003","muiOnErrorContainer":"#ffdad4","muiBackground":"#161818","muiOnBackground":"#e0e3e0","muiSurface":"#191c1b","muiOnSurface":"#e0e3e0","muiSurfaceVariant":"#3f4945","muiOnSurfaceVariant":"#bfc9c4","muiSurface1":"#202222","muiSurface2":"#252727","muiSurface3":"#292b2b","muiSurface4":"#2e3030","muiSurface5":"#323434","muiOutline":"#89938e","muiInverseOnSurface":"#191c1b","muiInverseSurface":"#e0e3e0","muiInversePrimary":"#006b55","muiWhite":"#fff","muiBlack":"#000","muiNeutral30":"#444846","muiNeutral40":"#5c5f5d","muiBoxShadow1":"\"0px 1px 3px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow2":"\"0px 2px 6px 2px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow3":"\"0px 4px 8px 3px rgba(0, 0, 0, 0.15), 0px 1px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow4":"\"0px 6px 10px 4px rgba(0, 0, 0, 0.15), 0px 2px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow5":"\"0px 8px 12px 6px rgba(0, 0, 0, 0.15), 0px 4px 4px rgba(0, 0, 0, 0.3)\"","idTarget":"landingpage_idTarget__domzG","fabulousText":"landingpage_fabulousText__kapLR","rainbow":"landingpage_rainbow__VPYez","errorText":"landingpage_errorText__7ICp3","landingpage":"landingpage_landingpage__fDTBl","buttonBox":"landingpage_buttonBox__T9d5y","gradientBox":"landingpage_gradientBox__yEoLK","jumbotron":"landingpage_jumbotron__13vAu","header":"landingpage_header__YudoD","headline":"landingpage_headline__5g35P","etournityLogo":"landingpage_etournityLogo__o05q3","createButton":"landingpage_createButton__5eexo","label":"landingpage_label__WPsIo","graphicsContainer":"landingpage_graphicsContainer__LQt1u","graphicsWrapper":"landingpage_graphicsWrapper__StwR9","matchlobbyBox":"landingpage_matchlobbyBox__e2eir","liHover":"landingpage_liHover__MEtBw","hosthubBox":"landingpage_hosthubBox__EVRPt","uspCards":"landingpage_uspCards__cC4rU","card":"landingpage_card__but9_","icon":"landingpage_icon__eE8av","title":"landingpage_title__ezaRG","body":"landingpage_body__wpgpr","middle":"landingpage_middle__HTtc6","backgroundBox":"landingpage_backgroundBox__TdUjL","brightEBackground":"landingpage_brightEBackground__nLwJp","footerAlpha":"landingpage_footerAlpha__X4Upa","textBox":"landingpage_textBox__ZKW02","publicAlpha":"landingpage_publicAlpha__534J8","alphaHeader":"landingpage_alphaHeader__g29gt","reminder":"landingpage_reminder__Yo_4d","discordBox":"landingpage_discordBox__tAkCg","joinOurDiscord":"landingpage_joinOurDiscord__eSGWN","logo":"landingpage_logo__JyTeG","footerMission":"landingpage_footerMission__i5snP","label2":"landingpage_label2__3rl0U"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(87314); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);